import React from "react";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import ReportsExportIcon from "../../assets/icons/reports_export.svg2";
import ReportsSavedIcon from "../../assets/icons/reports_saved.svg2";
import SaveIcon from "../../assets/icons/icon_save-01.svg2";
import WhiteButtonsContainer from "../Common/WhiteButtonsContainer";
import CustomIcon from "../../assets/icons/reports_generate.svg2";
import AssetsIcon from "../../assets/icons/asset-01.svg2";
import Subheading from "../Common/Subheading";
import NewFeature from "../Builder/Components/NewFeature";
import HelpButton from "../HelpContent/HelpButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

export default function ReportingAssets() {
  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <Subheading
              Icon={AssetsIcon}
              heading="Assets Statistics"
              subheading="See Asset data and asset events"
            />
          </div>
          <div className="d-flex justify-content-end">
            <WhiteButtonDropdown
              toggleHeading={"Actions"}
              toggleSubheading={"Assets Statistics"}
            >
              <WhiteButtonsContainer
                buttons={[
                  {
                    icon: ReportsSavedIcon,
                    as: "RRLink",
                    heading: "Saved",
                    subheading: "Reports",
                    to: "/assets/contacts/bulk",
                  },
                  {
                    icon: ReportsExportIcon,
                    as: "button",
                    heading: "Export",

                    subheading: "Report",
                    onClick: () => console.log("exported"),
                  },
                  {
                    icon: SaveIcon,
                    as: "button",
                    heading: "Save",
                    subheading: "Report",
                    onClick: () => console.log("saved"),
                  },
                  {
                    as: "RRLink",
                    to: "/reporting/topics",
                    icon: ContactsIcon,
                    heading: "Topics",
                    subheading: "Manage",
                  },
                  {
                    as: "RRLink",
                    to: "/reporting/templates",
                    icon: ContactsIcon,
                    heading: "Templates",
                    subheading: "Manage",
                  },
                  {
                    icon: CustomIcon,
                    as: "RRLink",
                    heading: "Custom",
                    subheading: "ReportBuilder",
                    to: "/reporting/custom",
                  },
                ]}
              />
            </WhiteButtonDropdown>
          </div>
        </div>
        <div className="my-3"> table</div>
      </NewFeature>
    </div>
  );
}
